import { SimplePage } from "@/app/_/marketing/SimplePage";
import { MultiEntityFeature } from "@/app/_/sections/3FeaturesSection/MultiEntityFeature";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="For multi-entity operators"
      title="Holdings, side projects, and intercompany — in one place."
      subtitle="Run multiple entities from a single workspace. Transfer transactions between companies, reconcile inter-entity receivables and payables, and report on each book without duplicating your stack."
      secondaryCta={{
        label: "Talk to us",
        to: "/company/contact",
      }}
      screenshot={{
        imageName: "multi-entity",
        alt: "Four entities managed from one workspace",
      }}
      capabilities={[
        {
          title: "Every book, one login.",
          description:
            "A fab shop, an agency, a SaaS company, a café — switch between them or work across all of them at once.",
          imageName: "crop-entity-switcher",
        },
        {
          title: "Each entity keeps its own accounts.",
          description:
            "Separate charts of accounts per company, with the intercompany receivable and payable kept in step on both sides.",
          imageName: "crop-coa-tree",
        },
        {
          title: "Report per company, or all together.",
          description:
            "Cash flow by entity, consolidated KPIs, and who-owes-what across your group on one dashboard.",
          imageName: "crop-report-widgets",
        },
      ]}
      illustration={{
        title: "Wired to the right entity.",
        description:
          "Accounts feed the company they belong to, and movements between your companies land on both books.",
        render: () => MultiEntityFeature().center.renderChildren(),
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/multi-entity", "/platform/reports"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
